import React from 'react';
import './style.scss';
import clsx from 'clsx';
import { withTranslation } from 'react-i18next';
import { dateItemFormatting } from '../../Shared/Helpers/dateTimeHelper';

/**
 * TimeFrame is used in src/components/PromotionListComponent/Item/index.js
 * it takes as props a start date and end date
 * The dates are displayed after a clock icon
 */
const TimeFrame = ({ props, validityEnd, validityStart, theme }) => {
  const { t, i18n } = props;
  const lang = i18n.language;

  return (
    <div className={clsx('global-time-frame flex-it flex-align-item-center', theme)}>
      <span className="global-time-frame-icon">
        <img src={`/-/jssmedia/Project/FAB2/shared/images/icon-clock.svg`} />
      </span>
      <span>
        {dateItemFormatting(validityStart?.value, validityEnd?.value, lang, 'm d y', t('yearOf'))}
      </span>
    </div>
  );
};

export default withTranslation()(TimeFrame);
